import { render, staticRenderFns } from "./TheNavBarItem.vue?vue&type=template&id=60a35028&scoped=true&"
import script from "./TheNavBarItem.vue?vue&type=script&lang=js&"
export * from "./TheNavBarItem.vue?vue&type=script&lang=js&"
import style0 from "./TheNavBarItem.vue?vue&type=style&index=0&id=60a35028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a35028",
  null
  
)

export default component.exports